import { render } from "./SiteEditPageHeader.vue?vue&type=template&id=3b6cbd88&scoped=true"
import script from "./SiteEditPageHeader.vue?vue&type=script&lang=js"
export * from "./SiteEditPageHeader.vue?vue&type=script&lang=js"

import "./SiteEditPageHeader.vue?vue&type=style&index=0&id=3b6cbd88&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6cbd88"]])

export default __exports__